module.exports = __webpack_public_path__ + "media/images/vp/icon.submenu.edu.red-9b3c7b78b2d62a7566afa0bd149917bb.svg";